import React, { Component, createRef } from 'react';
import LabelTemplate from './LabelTemplate';
import { LABELTEMPLATES, labelSizeTemplates, paperSizeTemplates } from '../../variables/framesStatics';

class LabelPrinter extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.state = {
            labels: [
                { barcode: '1234567890', name: 'Product 1', SKU: 'A123' },
                { barcode: '0987654321', name: 'Product 2', SKU: 'B123' },
                { barcode: '1122334455', name: 'Product 3', SKU: 'C123' },
                // More labels here
            ],
            totalPages: 0,
            labelsPerRow: 3,
            pageHeight: 0, // Track page height
        };
    }

    handlePrint = () => {
        this.setState({ scale: 1 }, () => {

            

            if (this.printRef.current) {
                const printContent = this.printRef.current.innerHTML;
                const { data } = this.props;

                const paperSize = paperSizeTemplates[data.paperSize];
                const labelSize = labelSizeTemplates[data.labelSize];


                const printFrame = document.createElement('iframe');
                printFrame.style.position = 'absolute';
                printFrame.style.width = '0px';
                printFrame.style.height = '0px';
                printFrame.style.border = 'none';
                document.body.appendChild(printFrame);

                const printDoc = printFrame.contentWindow.document;
                printDoc.open();
                printDoc.write(`
                <html>
                <head>
                    <title>Print Labels</title>
                    <style>
                        @page {
                            size: ${paperSize.width}mm ${paperSize.height}mm; /* Set paper size */
                            margin: 0; /* Remove default margins */
                        }
                        body {
                            margin: 0;
                            padding: 0;
                            width: ${paperSize.width}mm;
                            height: ${paperSize.height}mm;
                            display: flex;
                            flex-wrap: wrap;
                            align-items: center;
                            justify-content: center;
                            overflow: hidden;
                        }
                        .label-container {
                            width: 100%;
                            display: grid;
                            grid-template-columns: repeat(${this.state.labelsPerRow}, 1fr);
                            gap: 13px;
                             padding: 0px 0px 0px 1px;
                           
                            page-break-inside: avoid;
                        }
                        .label-item {
                            width: ${labelSize.width}mm;
                            height: ${labelSize.height}mm;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            
                            box-sizing: border-box;
                            page-break-after: auto;
                        }
                       
                    </style>
                </head>
                <body>
                    <div class="label-container">${printContent}</div>
                    <script>
                        window.onload = function() {
                            window.print();
                            setTimeout(() => window.close(), 100);
                        };
                    </script>
                </body>
                </html>
            `);
                printDoc.close();
                this.setState({ scale: this.props.scale })
            }
        })

    };


    calculatePages = () => {
        const { labels, data } = this.props;
        const paperSize = paperSizeTemplates[data.paperSize];
        const labelSize = labelSizeTemplates[data.labelSize];

        const paperWidth = paperSize.width;
        const paperHeight = paperSize.height;

        const labelWidth = labelSize.width;
        const labelHeight = labelSize.height;

        const labelGap = 2;

        const labelsPerRow = Math.floor((paperWidth + labelGap) / (labelWidth + labelGap));
        const totalRowGaps = (labelsPerRow - 1) * labelGap;
        const adjustedRowWidth = paperWidth - totalRowGaps;
        const labelsPerRowFinal = Math.floor(adjustedRowWidth / labelWidth);
        console.log('aaaaaaaaaaaaaaa', labelsPerRowFinal);
        const labelsPerColumn = Math.floor((paperHeight + labelGap) / (labelHeight + labelGap));
        const totalColumnGaps = (labelsPerColumn - 1) * labelGap;
        const adjustedColumnHeight = paperHeight - totalColumnGaps;
        const labelsPerColumnFinal = Math.floor(adjustedColumnHeight / labelHeight);

        const labelsPerPage = labelsPerRowFinal * labelsPerColumnFinal;
        const totalPages = Math.ceil(labels.length / labelsPerPage);

        this.setState({
            totalPages,
            labelsPerPage,
            labelsPerRow: labelsPerRowFinal,
            labelsPerColumn: labelsPerColumnFinal
        });
    };


    componentDidMount() {
        this.calculatePages();
        this.setState({ scale: this.props.scale })
    }

    render() {
        const { totalPages } = this.state;
        const { data, labels, scaledHeight } = this.props;

        return (
            <div className='p-2'>
                <div
                    ref={this.printRef}
                    className="label-container"
                    style={{
                        maxHeight: `${scaledHeight ?? 250}px`,
                        overflowY: 'auto',
                        display: 'grid',
                        gridTemplateColumns: ` repeat(${this.state.labelsPerRow}, 1fr)`,
                    }}
                >
                    {labels.map((element, index) => {

                        return (
                            <div key={index} className=''>
                                <LabelTemplate
                                    widthMM={labelSizeTemplates[data.labelSize].width}
                                    heightMM={labelSizeTemplates[data.labelSize].height}
                                    title={data.title}
                                    templateId={data.template}
                                    qrcode={data.qrCodeLink}
                                    scale={this.state.scale}
                                    key={index}
                                    code={element.barcode}
                                    text1={element.name}
                                    text2={element.SKU}
                                />

                                {/* Check if this is the last label of the page and draw a line */}
                                {(index + 1) % this.state.labelsPerPage === 0 && (
                                    <div className="separator" style={{ margin: '10px 0' }}></div>
                                )}
                            </div>
                        );
                    })}
                </div>


                <div className="page-count">
                    <p>Total Pages: {totalPages}</p>
                </div>

                <button onClick={this.handlePrint}>Print Labels</button>
            </div>
        );
    }
}

export default LabelPrinter;
